export const TOOL_APPROVAL_REQUESTED = "TOOL_APPROVAL_REQUESTED" as const;

export interface ClientRequirement {
  type: string;
  parameters: Record<string, string>;
}

export interface ToolApprovalRequestedEvent {
  type: typeof TOOL_APPROVAL_REQUESTED;
  toolApprovalId: string;
  conversationId: string;
  toolCallId: string;
  toolName: string;
  args: Record<string, unknown>;
  clientRequirements?: ClientRequirement[];
}
